/* ============================================================
   Butang × pada jalur "N slots failed" (tab Schedule, v3.9)

   Keputusan user 2026-09-18:
   - × hanya MENYOROK jalur merah. Status Failed KEKAL pada card (pil
     status) dan pada slot merah dalam kalendar — rekod tidak hilang.
   - Diingat dalam BROWSER ini sahaja. Pelanggan menjalankan satu tugasan
     pada satu browser, jadi tiada sebab menyegerakkannya ke browser lain.
     Tiada data kalendar atau server disentuh.
   - Jalur muncul SEMULA sendiri bila ada kegagalan BARU (slot lain gagal,
     atau slot yang sama gagal lagi selepas Retry / Run). Kiraan dan
     Retry all ketika itu hanya meliputi kegagalan yang belum ditutup.

   Bentuk storan (localStorage `sesaat_gagal_ditutup_v1`):
     { [akaunId]: { [`${pid}|${set}`]: sebab } }
   Dikunci ikut PRODUK+SET, bukan kunci slot: satu produk+set hanya boleh
   duduk dalam SATU slot bagi setiap akaun (seret = pindah, lihat `letakSet`
   dalam JadualTiktokV39), jadi kegagalan yang ditutup kekal ditutup walaupun
   slotnya dialih ke waktu lain.

   ⚠️ Kegagalan yang BERULANG dengan produk, set dan sebab yang SAMA hanya
      dikenali sebagai baru kerana slot itu melalui status lain dahulu —
      Retry/Run mencop 'running' pada slot sebelum hasilnya pulang. Effect
      dalam hook ini membuang tanda tutup sebaik slot itu kelihatan dengan
      status BUKAN 'failed'. Kalau kelak ada laluan yang menulis 'failed'
      terus di atas 'failed' tanpa status di tengah, kegagalan ulangan itu
      akan kekal tersorok — tambah cap masa kegagalan pada slot bila itu
      berlaku.
   ============================================================ */

import { useCallback, useEffect, useMemo, useSyncExternalStore } from 'react';

const KUNCI_STORAN = 'sesaat_gagal_ditutup_v1';
const PERISTIWA = 'sesaat-gagal-ditutup';

/* Tanda bagi produk yang dipadam / slot yang dibuang tidak dibersihkan
   (lihat `tandaBasi`), jadi senarai setiap akaun perlu siling. */
export const HAD_TANDA = 200;

/* Kalau storan browser menolak tulisan (penuh / disekat), × tetap berfungsi
   untuk sesi ini melalui salinan dalam ingatan — tanpa ini butang itu
   kelihatan rosak: ditekan, tiada apa berlaku. */
let salinanMemori = null;

const bacaMentah = () => {
    if (salinanMemori !== null) return salinanMemori;
    try { return localStorage.getItem(KUNCI_STORAN) || ''; } catch { return ''; }
};

const hurai = (mentah) => {
    if (!mentah) return {};
    try {
        const v = JSON.parse(mentah);
        return (v && typeof v === 'object' && !Array.isArray(v)) ? v : {};
    } catch { return {}; }
};

/* Dengar tulisan tab ini (peristiwa sendiri) DAN tab lain browser yang sama
   (peristiwa `storage`), supaya dua tab webapp tidak memapar jawapan berbeza. */
const langgan = (panggil) => {
    const dariTabLain = (e) => { if (!e.key || e.key === KUNCI_STORAN) panggil(); };
    window.addEventListener('storage', dariTabLain);
    window.addEventListener(PERISTIWA, panggil);
    return () => {
        window.removeEventListener('storage', dariTabLain);
        window.removeEventListener(PERISTIWA, panggil);
    };
};

/* Satu pintu tulisan. Storan dibaca SEMULA sebelum ditulis supaya tanda
   akaun lain (atau tulisan tab lain) tidak ditimpa. */
const ubahAkaun = (akaunId, fn) => {
    const semua = hurai(bacaMentah());
    const baru = fn({ ...(semua[akaunId] || {}) });
    if (baru && Object.keys(baru).length) semua[akaunId] = baru;
    else delete semua[akaunId];
    const json = JSON.stringify(semua);
    if (salinanMemori !== null) {
        salinanMemori = json;
    } else {
        try { localStorage.setItem(KUNCI_STORAN, json); } catch { salinanMemori = json; }
    }
    window.dispatchEvent(new Event(PERISTIWA));
};

const ada = (obj, k) => Object.prototype.hasOwnProperty.call(obj, k);

/* Identiti satu produk+set dalam SATU akaun kalendar. */
export const idSetSlot = (e) => `${e?.pid || ''}|${e?.s || ''}`;

/* Slot GAGAL yang belum ditutup — inilah yang jalur kira dan Retry all ulang.
   `isian` = isian PAPAR kalendar ({ [kunciSlot]: { pid, s, st, sb, … } }). */
export function kunciGagalTunjuk(isian = {}, tanda = {}) {
    return Object.keys(isian).filter((k) => {
        const e = isian[k];
        if (!e || e.st !== 'failed') return false;
        const id = idSetSlot(e);
        return !(ada(tanda, id) && tanda[id] === (e.sb || ''));
    });
}

/* Tanda yang sudah basi: produk+set itu kini duduk dalam slot yang BUKAN
   gagal, atau gagal dengan sebab lain.

   ⛔ Produk+set yang TIADA dalam paparan SENGAJA dibiarkan. Semasa halaman
      baru dibuka, senarai produk boleh masih kosong (slot belum dipadankan);
      membuang tandanya pada saat itu akan memunculkan semula jalur yang
      pengguna sudah tutup, setiap kali halaman dimuat semula. */
export function tandaBasi(isian = {}, tanda = {}) {
    const ikutId = new Map();
    for (const k in isian) {
        const e = isian[k];
        if (e) ikutId.set(idSetSlot(e), e);
    }
    return Object.keys(tanda).filter((id) => {
        const e = ikutId.get(id);
        if (!e) return false;
        return e.st !== 'failed' || (e.sb || '') !== tanda[id];
    });
}

/* Tambah tanda bagi slot yang ditutup. Susunan kunci = umur (yang ditutup
   semula diletak di hujung), jadi siling membuang yang TERTUA dahulu. */
export function tambahTanda(tanda = {}, isian = {}, kunci = []) {
    const baru = { ...tanda };
    kunci.forEach((k) => {
        const e = isian[k];
        if (!e) return;
        const id = idSetSlot(e);
        delete baru[id];
        baru[id] = e.sb || '';
    });
    const semua = Object.keys(baru);
    semua.slice(0, Math.max(0, semua.length - HAD_TANDA)).forEach((id) => { delete baru[id]; });
    return baru;
}

/* Pulang { kunciTunjuk, tutup }:
   `kunciTunjuk` = kunci slot gagal yang masih perlu dipapar pada jalur;
   `tutup()`     = sorok semua kegagalan yang sedang dipapar. */
export function useGagalDitutup(akaunId, isian) {
    const mentah = useSyncExternalStore(langgan, bacaMentah, () => '');
    const tanda = useMemo(() => hurai(mentah)[akaunId] || {}, [mentah, akaunId]);
    const kunciTunjuk = useMemo(() => kunciGagalTunjuk(isian || {}, tanda), [isian, tanda]);

    /* Buang tanda yang basi sebaik ia kelihatan (lihat nota ⚠️ di kepala fail).
       Idempoten: pusingan kedua tidak menemui apa-apa lagi untuk dibuang,
       jadi StrictMode yang menjalankannya dua kali tidak berbahaya. */
    useEffect(() => {
        if (!akaunId) return;
        const basi = tandaBasi(isian || {}, tanda);
        if (!basi.length) return;
        ubahAkaun(akaunId, (lama) => {
            basi.forEach((id) => { delete lama[id]; });
            return lama;
        });
    }, [akaunId, isian, tanda]);

    const tutup = useCallback(() => {
        if (!akaunId || !kunciTunjuk.length) return;
        ubahAkaun(akaunId, (lama) => tambahTanda(lama, isian || {}, kunciTunjuk));
    }, [akaunId, isian, kunciTunjuk]);

    return { kunciTunjuk, tutup };
}
